module.exports = __webpack_public_path__ + "static/media/kv-en.939fa460.jpg";